module.exports = __webpack_public_path__ + "img/banner4.eb1e3866.png";